import { format, isAfter, isBefore, isToday, startOfDay } from "date-fns";

import { cx } from "@/utils";

import { useCalendar } from "../CalendarContext";

import styles from "./Day.module.css";

interface DayProps {
  date: Date;
  selected?: boolean;
  onClick?: (d: Date) => void;
  disabled?: boolean;
  blur?: boolean;
}

const Day: React.FC<DayProps> = ({
  date,
  blur,
  selected,
  disabled: passedDisabled,
  onClick,
}) => {
  const formattedDate = format(date, "d");
  const settings = useCalendar();
  const disabled =
    passedDisabled ||
    (settings.max && isAfter(startOfDay(date), startOfDay(settings.max))) ||
    (settings.min && isBefore(startOfDay(date), startOfDay(settings.min)));

  return (
    <button
      type="button"
      className={cx(styles.root, {
        [styles.selected]: selected,
        [styles.clickable]: onClick && !disabled,
        [styles.today]: isToday(date),
        [styles.blur]: blur,
      })}
      disabled={disabled}
      aria-disabled={disabled}
      onClick={onClick ? () => onClick(date) : undefined}
    >
      <span>{formattedDate}</span>
    </button>
  );
};

export default Day;
